
import { defineComponent } from "vue";

//import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import * as Yup from "yup";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "new-entity-course",
  components: {
    Datatable,
  },

  data() {
    return {
      batch: {},
      employee: {
        registration_date: "",
      },
      details: {},
      weekplan: {},
      entityTypes: [],
      industry: [],
      entityInfos: [],
      divisions: [],
      districts: [],
      subDistricts: [],
      empDistricts: [],
      tableData: [
        {
          id: 1,
          image: "",
          name: "Razowan",
          father_name: "Abdul Motaleb",
          mother_name: "Rocksana Begum",
          nid: "124598563254",
          phone: "01741255213",
          dob: "1986-01-10",
        },
        {
          id: 2,
          image: "",
          name: "Abdullah",
          father_name: "Abdul Karim",
          mother_name: "Parvin Begum",
          nid: "124598563254",
          phone: "01741255212",
          dob: "1986-01-12",
        },
      ],

      tableHeader: [
        {
          name: "Image",
          key: "image",
          sortable: true,
          width: "5px",
        },
        {
          name: "Name",
          key: "name",
          sortable: true,
        },
        {
          name: "Father Name",
          key: "father_name",
          sortable: true,
        },
        {
          name: "Mother Name",
          key: "mother_name",
          sortable: true,
        },
        {
          name: "NID",
          key: "nid",
          sortable: true,
        },
        {
          name: "Phone",
          key: "phone",
          sortable: true,
        },
        {
          name: "DoB",
          key: "dob",
          sortable: true,
        },
      ],
      employementTableData: [
        {
          id: 1,
          sl: 1,

          name: "M/S Hoq Engineering Works",
          designation: "Welder",
          salary: "7000	",
          join_date: "05-11-2016",
          release_date: "Till Date",
          duration: "63.57",
        },
        {
          id: 2,
          sl: 2,
          image: "",
          name: "M/S Hoq Engineering Works",
          designation: "Tecnical Operator",
          salary: "8000	",
          join_date: "05-11-2016",
          release_date: "Till Date	",
          duration: "63.57",
        },
      ],
      EmploymenttableHeader: [
        {
          name: "SN",
          key: "sl",
          sortable: true,
          width: "5px",
        },
        {
          name: "Organization",
          key: "name",
          sortable: true,
        },
        {
          name: "Designation",
          key: "designation",
          sortable: true,
        },
        {
          name: "Salary",
          key: "salary",
          sortable: true,
        },
        {
          name: "Joining Date",
          key: "join_date",
          sortable: true,
        },

        {
          name: "Release Date",
          key: "release_date",
          sortable: true,
        },
        {
          name: "Durations",
          key: "duration",
          sortable: true,
        },
      ],
      loading: false,
      courseInfoData: false,
      showCourseNotice: false,
      showtrainingProviderNotice: false,
    };
  },
  async created() {
    await this.getEntityTypes();
    await this.getEntityInfos();
  },
  methods: {
    async formSubmit() {
      //form submit
    },
    async getEntityInfos() {
      await ApiService.get("entity/infos")
        .then((response) => {
          this.entityInfos = response.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async getEntityTypes() {
      await ApiService.get("entity/types")
        .then((response) => {
          this.entityTypes = response.data;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    courseInfo() {
      this.courseInfoData = true;
    },
    courseNotice() {
      this.showCourseNotice = true;
    },
    trainingProviderNotice() {
      this.showtrainingProviderNotice = true;
    },
  },
  setup() {
    const AssociationSchema = Yup.object().shape({
      email: Yup.string()
        .email("Must be valid email")
        .required()
        .label("Email"),
      web_url: Yup.string().required().label("Web Url"),
      postcode: Yup.string().required().max(4).label("Postcode"),
      registration_number: Yup.string().required().label("Registration Number"),
      registration_authority: Yup.string()
        .required()
        .label("Registration Authority"),
      telephone: Yup.number().required().min(11).label("Telephone"),
      entity_name: Yup.string().required().label("Name"),
      entity_short_name: Yup.string().required().label("Short Name"),

      employeeEmail: Yup.string()
        .email("Must be valid email")
        .required()
        .label("Email"),
      //presentDistrict: Yup.string().required().label("Present District"),
      name: Yup.string().required().label("Name"),
      designation: Yup.string().required().label("Designation"),
      gender: Yup.string().required().label("Gender"),
      mobile: Yup.number().required().min(11).label("Mobile"),
      dob: Yup.string().required().label("Date of Birth"),

      password: Yup.string()
        .required()
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/,
          "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
        )
        .label("Password"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Password didn't match!")
        .label("Confirm Password"),
    });
    return {
      AssociationSchema,
    };
  },
});
